<template>
  <car-finance-list :vendor="'2'"></car-finance-list>
</template>

<script>
import CarFinanceList from '@/components/CarFinanceList';

export default {
  name: 'TACFinanceList',
  components: { CarFinanceList }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/TACFinanceList.vue